import { PlanSibling } from '@anm/api/modules/pricing';
import { useCallback } from 'react';

import { PricingTablePlan } from '../types';
import { isEqual } from 'lodash/fp';

type UseSiblingSwitcherProps = {
  siblings?: PricingTablePlan[];
  change: (newItem: PricingTablePlan) => void;
};
const useSiblingSwitcher = ({ siblings, change }: UseSiblingSwitcherProps) => {
  const onSiblingChange = useCallback(
    (newSibling: PlanSibling) => {
      if (siblings) {
        const siblingPlan = siblings.find(({ sibling }) => isEqual(sibling, newSibling));
        siblingPlan && change(siblingPlan);
      }
    },
    [change, siblings]
  );

  return { onSiblingChange };
};

export default useSiblingSwitcher;
